import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import '../style2.css' ;
import ScrolltoTop from "../components/ScrolltoTop";

const TermsCondition = () => {
    return(
        <>
        <Navbar/>

        <div className="terms-container">
      <h1>Terms & Conditions</h1>

      <section>
        <h2>GUEST NAMES</h2>
        <p>Passport copy(s) of the guest(s) must be submitted to TIRUN at the time of booking the cruise. It is the responsibility of the guest(s) to ensure that the names and date of birth are as per the passport. Under security considerations, any variations can result in denied boarding.</p>
      </section>

      <section>
        <h2>PAYMENT TERMS</h2>
        <h3>ROYAL CARIBBEAN INTERNATIONAL :</h3>
        <h3>Deposit Payment</h3>
        <table>
          <thead>
            <tr><th>No. of Nights</th><th>Deposit (Per Person)</th></tr>
          </thead>
          <tbody>
            <tr><td>1–5 Nights</td><td>USD 150.00</td></tr>
            <tr><td>6–9 Nights</td><td>USD 350.00</td></tr>
            <tr><td>10+ Nights</td><td>USD 500.00</td></tr>
            <tr><td>All Suites including the GTY</td><td>10% of the cruise fare or standard deposit (whichever is higher)</td></tr>
          </tbody>
        </table>

        <h3>Final Payment</h3>
        <table>
          <thead>
            <tr><th>Itinerary</th><th>Days Prior to Sail Date</th></tr>
          </thead>
          <tbody>
            <tr><td>1–5 Nights</td><td>76 days</td></tr>
            <tr><td>6–14 Nights</td><td>91 days</td></tr>
            <tr><td>15+ Nights</td><td>120 days</td></tr>
          </tbody>
        </table>

     
        
        <h3>CELEBRITY CRUISES :</h3>
        <h3>Deposit Payment</h3>
        <table>
          <thead>
            <tr><th>No. of Nights</th><th>Deposit (Per Person)</th></tr>
          </thead>
          <tbody>
            <tr><td>1–5 Nights</td><td>USD 100.00</td></tr>
            <tr><td>6–9 Nights</td><td>USD 250.00</td></tr>
            <tr><td>10+ Nights</td><td>USD 450.00</td></tr>
            <tr><td>All Suites including the GTY</td><td>10% of the cruise fare or standard deposit (whichever is higher)</td></tr>
          </tbody>
        </table>

        <h3>Final Payment</h3>
        <table>
          <thead>
            <tr><th>Itinerary</th><th>Days Prior to Sail Date</th></tr>
          </thead>
          <tbody>
            <tr><td>1–9 Nights</td><td>60 days</td></tr>
            <tr><td>10+ Nights</td><td>75 days</td></tr>
            <tr><td>CruiseTours & Holiday Sailings *<br></br>(*Holiday sailings = sailings over Thanksgiving, Christmas & New Year, Chinese New Year etc.)</td><td>91 days</td></tr>
          </tbody>
        </table>

        <h3>Celebrity Xpeditions Bookings</h3>
        <h3>Celebrity Flora</h3>
        <table>
          {/* <thead>
            <tr><th>Itinerary</th><th>Days Prior to Sail Date</th></tr>
          </thead> */}
          <tbody>
            <tr><td>Deposit Payment</td><td>$900 per pax
*Deposit for the Retreat (suites) will now be the greater of 10% or standard deposit amount.
</td></tr>
            <tr><td>Final Payment</td><td>120 days to sailing</td></tr>
            {/* <tr><td>CruiseTours & Holiday Sailings *<br></br>(*Holiday sailings = sailings over Thanksgiving, Christmas & New Year, Chinese New Year etc.)</td><td>91 days</td></tr> */}
          </tbody>
        </table>


        <h3>Payment Options</h3>
        <p>A choice of 3 payment options including;</p>
        <ul>
          <li>	Payment in Indian Rupees at the prevalent rate of exchange via RTGS, should be payable to TIRUN Travel Marketing.
RTGS* details available on request.
</li>
          <li>	Payment in US Dollars per RBI guidelines – Currency or Electronic Wire Transfer (USD account bank details available upon request). </li>
          <li> Payment by credit card – American Express, MasterCard & Visa. (The cruise line will be the merchant establishment)</li>
        </ul>
        <p>TCS will be charged as applicable.</p>

      </section>

      <section>
        <h2>STATUTORY COMPLIANCE</h2>
        <p>By paying TIRUN, you/your guest acknowledge that you are in compliance with the RBI’s Liberalization Remittance Scheme (LRS) limit of USD 250,000 per individual Traveler for the financial year. Further, TIRUN may from time-to-time request guest / travel agent to submit a LRS declaration stating compliance.<br></br><br></br>

All transactions will be governed by RBI guidelines. Government taxes including goods and service tax, levies and fees, as applicable, on the transactions involved will be the liability of the guest / travel agent.
</p>
      </section>

      <section id="Cancellation-policy">
        <h2>CANCELLATION TERMS</h2>
        <p>The cancellation policy for your cruise (including cruise fare, NCCF and taxes/fees) are as set forth below:</p>
        <p>Note</p>
        <ul>
        <li>The first stage of penalty - No Charge - is applicable only for refundable deposit bookings.</li>
        <li>For Non-refundable deposit booking, the penalty of the deposit amount is charged from the day payment is received.</li>
        <li>From Stage 2 – Deposit Amount - the cancellation penalty is same for both Refundable & Non Refundable</li>
        <li>Guests booked under non refundable deposit program guests can change the ship/sail date by paying a service fee of USD 100.00 per person before the final payment due date.</li>
        </ul>
        <h3>ROYAL CARIBBEAN INTERNATIONAL</h3>
        <table>
          <thead>
            <tr><th>Itineraries</th><th>Days Prior to Sailing Date</th><th>Cancellation Charges (Per Person)</th></tr>
          </thead>
          <tbody>
            <tr><td>1 to 5 Nights</td><td>75 or more days <br></br>74 to 60 days<br></br>
59 to 30 days<br></br>
29 to 15 days<br></br>
14 or less days
</td><td>No Charge<br></br>
Full Deposit Amount <br></br>50% of Total Price * <br></br>75% of Total Price *<br></br>
No Refund
</td></tr>
            <tr><td>6 -9 Nights</td><td>90 or more days <br></br>89 to 75 days<br></br>
74 to 45 days<br></br>
44 to 15 days <br></br>14 or less days
</td><td>No Charge<br></br>
Full Deposit Amount <br></br>50 % of Total Price * <br></br>75 % of Total Price *<br></br> No Refund
</td></tr>
            <tr><td>10-14 Nights</td><td>90 or more days <br></br>89 to 75 days<br></br>
74 to 61 days<br></br>
60 to 31 days <br></br>30 or less days
</td><td>No Charge<br></br>
Full Deposit Amount<br></br> 50% of Total price * <br></br>75% of Total price * <br></br> No refund
</td></tr>
            <tr><td>15+ Nights</td><td>121 or more days <br></br>120 to 61 days<br></br>
60 to 41 days<br></br>
40 to 25 days <br></br>24 or less days
</td><td>No Charge <br></br>25% of Total price<br></br>
5T% of Total Price* <br></br>75% of Total Price*<br></br> No refund
</td></tr>
           
          </tbody>
        </table>
        <p>*Or deposit amount, whichever is greater.</p>



        <h3>CELEBRITY CRUISES</h3>
        <table>
          <thead>
            <tr><th>Itineraries</th><th>Days Prior to Sailing Date</th><th>Cancellation Charges (Per Person)</th></tr>
          </thead>
          <tbody>
            <tr><td>1 to 5 Nights</td><td>60 Days or more<br></br>
            59 - 45 days<br></br>
            44 - 15 days<br></br>
            14 or less days
</td><td>No Charge<br></br>
Full Deposit Amount <br></br> 50% of the Total cost*<br></br>
No Refund
</td></tr>
            <tr><td>6 -9 Nights</td><td>60 Days or more<br></br>
            59 - 45 days<br></br>
            44 - 15 days<br></br>
            14 or less days
</td><td>No Charge<br></br>
Full Deposit Amount<br></br>50% of the Total cost*<br></br> No Refund
</td></tr>
            <tr><td>10 Nights or longer</td><td>75 Days or more<br></br>
            74 - 45 days<br></br>
            44 - 15 days<br></br>
            14 or less days
</td><td>No Charge<br></br>
Full Deposit Amount<br></br> 50% of the Total cost*<br></br> No refund
</td></tr>
            <tr><td>Cruise Tours</td><td>75 Days or more<br></br>
            74 - 57 days<br></br>
            56 -29 days<br></br>
            28-15 days<br></br>
            14 or less days
</td><td>No Charge <br></br>Full Deposit Amount<br></br>50% of the Total cost*<br></br> 75% of the Total cost<br></br>No Refund
</td></tr>
           
          </tbody>
        </table>
        {/* <p>*Or deposit amount, whichever is greater.</p> */}


        <h3>Holiday Sailings</h3>
        <table>
          <thead>
            <tr><th>Itineraries</th><th>Days Prior to Sailing Date</th><th>Cancellation Charges (Per Person)</th></tr>
          </thead>
          <tbody>
            <tr><td>1 to 5 Nights</td>
            <td>90 Days or more<br></br>
            89 - 30 days<br></br>
            29 - 15 days<br></br>
            14 or less days
           </td>
<td>No Charge<br></br>
Full Deposit Amount <br></br>
50% of Total Cost* <br></br>
No Refund
</td></tr>
            <tr><td>6 Nights or Longer</td>
            <td>90 or more days <br></br>
            89 - 60 days<br></br>
            59 - 15 days<br></br>
           14 or less days
</td><td>No Charge<br></br>
Full Deposit Amount <br></br>
50 % of Total Cost* <br></br>
 No Refund
</td></tr>
            
          </tbody>
        </table>



        <h3>Celebrity Flora</h3>
        <table>
          <thead>
            <tr><th>Itineraries</th><th>Days Prior to Sailing Date</th><th>Cancellation Charges (Per Person)</th></tr>
          </thead>
          <tbody>
            <tr><td></td>
            <td>120 Days or more<br></br>
            119 - 89 days<br></br>
            88 - 43 days<br></br>
            42 - 22 days<br></br>
            21 or less days
           </td>
<td>No Charge<br></br>
US $ 900 per pax <br></br>
50% of Total Cost* <br></br>
75% of Total Cost* <br></br>
No Refund
</td></tr>   
          </tbody>
        </table>
        <p>*Or deposit amount, whichever is greater.</p>
        <p>**Guests who convert their cruise tours to a cruise only booking within 42 days of the start date of the tour segment of the cruise tour will be subject to a cancellation charge. The amount of that charge varies depending on the location of the cruise tour and/or its length</p>
        <p># Cancellation charges are assessed based on days prior to the start of the cruise tour package or days prior to the sailing whichever is earlier.</p>

        <h3>NOTE:</h3>

        <ul>
          <li>	Cancellations must be sent in writing and on a working day for us to action appropriately.</li>
          <li>	Payments and Cancellation terms are subject to change without prior notice. Refunds will only be in Indian Rupees and subject to rate of exchange, as applicable </li>
        </ul>

      </section>



      <section>
        <h2>ITINERARY CHANGES OR DEVIATION</h2>
        <p>The departure & arrival times are not guaranteed, and any part of the itinerary are subject to delays and to port of call cancellation occasioned by weather conditions, emergencies of safe navigation, navigation through regulated water, ports and channels and other causes beyond the control of the Cruise Line and may be changed at any time at the Cruise Lines sole discretion.</p>
      </section>
      
      <section>
        <h2>TRAVEL DOCUMENTS</h2>
        <p>Please familiarize yourself with the required travel documents you will be asked to provide prior to boarding the cruise ship.</p>
        <p>Passport: A valid passport is required for travel. For your protection, we recommend that your passport expiration date does not occur within six (6) months of the sailing termination date.</p>
        <p>Visa: It is the guests’ responsibility to identify and to obtain the necessary visas before commencing their cruise itinerary. As a ready reckoner and based on information available with us, you may visit   
          <a href="/docs/VISA TRAVEL DOCUMENTS.pdf" // Replace with actual path
            target="_blank"
            rel="noopener noreferrer"> http://www.tirun.com/cruises/terms/Travel Documents.pdf</a> or refer to the attached visa document for information or visiting as appropriate. However, current and up-to-date visa information is best sourced from the Embassy / Consulate of the country proposed to be visited, and, neither TIRUN Travel Marketing, nor, the cruise line can be held responsible for visa procurement and rules and regulations of various countries to be visited on your cruise ship itinerary.</p>
        <p>It is the sole responsibility of the guest to identify and obtain all necessary travel documents and have them available when necessary. These appropriate valid travel documents such as passports and visas are required for boarding the ship and entry into the countries to be visited on the guest’s cruise. Guests who do not possess proper documentation may be prevented from boarding the ship or entering a country to be visited on their cruise and may be subject to fines. No refunds will be given to individuals who fail to bring proper documentation.</p>
      </section>


      <section>
        <h2>GUARANTEE STATEROOM</h2>
        <p>A ‘Guarantee’ means you are guaranteed the stateroom category of choice, however, the stateroom number is allocated at the discretion of the cruise line, any time after full payment and or up to check-in. </p>
        <p>Please note that
your stateroom could be allocated on any deck & may / may not have an obstructed view or be wheel chair accessible. For guests travelling with families, and have booked two or more guarantee staterooms, please be advised that rooms can be allotted on any deck, not necessarily on the same deck or near each other.
</p>
      </section>


      <section>
        <h2>THIRD/FOURTH GUESTS</h2>
        <p>Staterooms allocated in triple & quad occupancy cannot be utilized as doubles. The cruise line may require that staterooms with the capacity to accommodate three or more guests be fully occupied. The cruise line reserves the right to move guests to a comparable stateroom with the appropriate number of berths if (i) Travel Partner books a stateroom with fewer than the maximum number of guests that the stateroom can accommodate, or (ii)a guest cancellation occurs, and the remaining number of guests do not match the maximum number of guests the stateroom can accommodate. </p>
      </section>

      <section>
        <h2>CRUISE FARE INCLUDES</h2>
        <p>Shipboard accommodation as reserved and paid for, ocean transportation per itinerary, all meals, some non- alcoholic beverages available in vending machines (including, tea, coffee, lemonade and iced-tea), 24-hours Room Service*, and recreation and entertainment as provided onboard. All guests have unlimited free access to almost all public areas on board the ship.</p>
        <p>Royal Caribbean International - Room service is available onboard any time of the day or night – simply order from the room service menu located in your stateroom/suite. Royal Caribbean International® has a convenience fee @ $7. 95 per delivery is intended to minimize onboard food waste. However, the continental breakfast per menu will be free.</p>
        <p>Celebrity Cruises: 24-hour room service is available any time of the day or night - simply order from the room service menu located in your stateroom (Room service fee of $9.95* applies). An 18% gratuity is additional and will automatically be added to your check.</p>
        <p>Continental breakfast room service is complimentary. Available from 6am – 11am each day of the cruise except disembarkation day.</p>
        <p>*Room service fee is subject to change without notice. 24-hour room service is complimentary for guests of The Retreat and Zenith Captain Club members.</p>
      </section>

      <section>
        <h2>CRUISE FARE DOES NOT INCLUDE</h2>
        <p>Items of a strictly personal nature, such as, shore excursions, bar beverages, dining in the specialty restaurants, laundry, telephone calls, photographs, medical services, gratuities, casino chips, onboard shopping, or other items not specifically stated as included in the cruise fare.</p>
      </section>

     
     <section>
      <h2>GRATUITIES</h2>
      <p>The gratuities automatically adds gratuities** to guests’ onboard SeaPass® account, except for guests in Excluded Bookings*, as defined below, in the following amounts for sailings commencing on or after July 10, 2023:</p>
     </section>

     <section>
      <h2>ROYAL CARIBBEAN INTERNATIONAL</h2>
      <ul>
        <li>$ 18.50 per person per day for guests in staterooms</li>
        <li> 21.00 per person per day for guests in suites.</li>
        </ul>
     </section>


     <section>
      <h2>CELEBRITY CRUISES</h2>
      <ul>
        <li>$18.00 USD per person, per day for Inside, Ocean View, and Veranda staterooms</li>
        <li> $19.00 USD per person, per day for Concierge Class and AquaClass staterooms</li>
        <li>$23.00 USD per person, per day for guests of The Retreat.</li>
        </ul>
        <p>Note: It is recommended that guest prepays the gratuities at the time of final payment, so that thereafter guest does not have to worry about paying gratuities on board.</p>
        <p>A 20% gratuity will automatically be added to your bar bill or wine check when you are served.</p>
     </section>


      <section>
        <h2>FOOD</h2>
        <p>Due Public health and Safety guidelines, Only Sealed and Commercially prepared Snacks can be brought onboard. Raw Grocery items and Opened packets of snacks will not be allowed onboard.</p>
        <p>The buffet restaurant onboard, offers a wide variety of cuisine including Indian Food. In the interest of other passengers and hygiene, it is important not to crowd around the buffet table and use clean hands, for service.</p>
      </section>

      <section>
        <h2>SWIM WEAR</h2>
        <p>In the interest of all passengers & hygiene, it is mandatory to use “Swim Wear” in the pools/ whirlpools. “Non- Swim Wear” clothing will not be permitted in these areas.</p>
      </section>

      <section>
        <h2>AGE POLICY</h2>
        <h3>Minor in Stateroom:</h3>
        <p>No guest under the age of 21 will be booked in a stateroom unless accompanied by an adult 21 years or older. This age limit will be waived for minor children sailing with their parents or guardians in adjacent staterooms.</p>
      
        <h3>Infant Policy:</h3>
        <p>Infants sailing on a cruise must be at least 6 months old as of the first day of the cruise and/or Cruisetour. HOWEVER: For transatlantic, transpacific, Hawaii, select South American and other selected cruises and/or Cruisetours, the infant must be at least 12 months old as of the first day of the cruise/Cruisetour. For the purposes of this policy, any cruise that has 3 or more consecutive days at sea will require infants to be at least 12 months old on the first day of the cruise/Cruisetour.</p>

        <h3>Minors Not Accompanied by A Legal Guardian:</h3>
        <p>Adults who are not the parent or Legal Guardian of any minor child travelling with them are required to present the child’s valid passport and visa (or certified copy of the child’s birth certificate) and an original notarized letter signed by at least one of the child’s parents. The letter notarized letter from the child’s parent must authorize the travelling adult to take the child on the specific cruise and must authorize the travelling adult to supervise the child and permit any medical treatment that must be administered to the child. If a nonparent adult is a Legal Guardian, the adult must present a certified certificate of Guardianship with respect to the child.</p>


        <h3>Casino Age Policy:</h3>
        <p>Everyone 18 years and older is welcome to play, some Alaskan ports require a minimum age of 21.</p>


        <h3>Alcohol Policy:</h3>
        <p>The cruise line expects to be responsible for their actions at all times, including during transfers to and from ships, inside terminals, while onboard, at our ports of call, during shore excursions and at our private destinations. Consuming alcohol to excess impairs one's judgment and reduces one's ability to recognize and avoid potentially dangerous situations. Guests who choose to consume alcohol must do so responsibly. The ship's staff may refuse to serve alcoholic beverages to any guest who does not consume alcohol responsibly, including those who have purchased an all-inclusive beverage package. Ship's personnel may request verification of a guest's age to verify they are of age to consume alcohol pursuant to this policy. Any guest that violates this alcohol policy will be considered for disciplinary action pursuant to the "Consequences Section" of this Guest Conduct Policy and may lose their privileges to use areas or facilities of the ship.</p>
        <p>Guests are not permitted to bring alcoholic beverages onboard; except for embarkation day when guests are permitted to bring onboard with them up to two (2) bottles of wine (which are subject to a corkage fee of $ 25.00 per bottle) per stateroom. Security may inspect containers (including water bottles, soda bottles, mouthwash, canteens, etc.) at any time and will dispose of alcohol concealed in such containers. Alcoholic beverages that are purchased from onboard shops or in ports of call (which must be presented to security upon re-boarding), will be secured by ship's personnel. Alcohol secured by ship's personnel will be returned to guests just prior to the conclusion of their cruise vacation. Guests who are under the permitted drinking age will not have alcohol returned to them.</p>
        <p>The minimum drinking age for all alcoholic beverages on Celebrity Cruises® ships sailing from North America is 21. The minimum drinking age for all alcoholic beverages on Celebrity Cruises® ships sailing from South America, Europe, Asia, Australia, and New Zealand is 18. In certain circumstances where local laws permit or require, Celebrity Cruises® may modify this policy which may also require parent/guardian request/authorization. Guests may contact Guest Relations or refer to Celebrity Today for specific minimum drinking age information on their cruise vacation.</p>
        <p>For purposes of complying with the minimum drinking age requirements, a guest's age is established upon boarding at the beginning of the cruise vacation. If a guest celebrates their birthday during the cruise vacation, and thereby becomes of age to consume alcohol, the guest may thereafter ask the Guest Relations Manager to modify ship's records to permit their consumption of alcohol during the remainder of the vacation. The guest will be required to appear at Guest Relations to present a valid government-issued form of identification to permit verification of their age.</p>
        <p>No guest under age 18 may possess or consume alcohol at any time while onboard. No guest under age 21 may possess or consume alcohol at our private destinations. Any guest who goes ashore and consumes alcohol (whether under the supervision of a parent/guardian or not, is responsible for ensuring they consume responsibly and retain their ability to recognize and avoid potentially dangerous situations when they return to the ship. Parents/guardians are reminded they are responsible for the actions of their child/young adult at all times while on a Celebrity Cruises® cruise vacation.</p>
        <p>Guests who violate any alcohol policy, including but not limited to underage drinking; providing alcohol to minors or young adults; possessing, concealing or attempting to conceal alcoholic items in their luggage, when boarding or while onboard; engaging in alcohol drinking games; or failing to consume alcohol responsibly, will be considered for discipline under the provisions of this policy.</p>
        <p>The cruise line will not accept guests who have entered their 24th week of pregnancy by the beginning of, or at any time during their cruise vacation. A physician’s “Fit to Travel” note is required prior to sailing, stating how far along (in weeks) the guest’s pregnancy will be at the beginning of the cruise and confirming that the guest is in good health and not experiencing a high-risk pregnancy.</p>



      </section>

      <section>
        <h2>ONLINE CHECK-IN</h2>
        <p>When it’s time to check in, we recommend you use the Celebrity App / Royal Caribbean App to check in all guests on your reservation. The app provides a quick and easy check-in process so you can start your vacation sooner. Updates include:</p>
        <ul>
          <li>Your arrival time at the terminal - a scheduled arrival time at the terminal on your sail date</li>
          <li>The required Health Questionnaire – only available in advance in the app</li>
          <li>Our reimagined Safety Briefing - Simply tap the Safety icon on the homepage to launch the Safety Briefing, whether you’re in the terminal or you’ve just stepped onboard, to complete the first steps of the Safety Briefing before heading to your assigned Assembly Station. Remember all guests must complete the Safety Briefing before the ship can sail.</li>
          <li>Extended app check in window - Check in using the app until 48 hours prior your sailing time.</li>
       <p>We highly recommend completing check in using the app for the easiest, fastest, and complete check-in experience.</p>
      <p>The cruise lines requires guests to be checked in no later than 90 minutes prior to the scheduled sailing time*. Guests arriving late will not be permitted to sail.</p>
      <p>When you Check-In at the terminal, show your SetSail Pass in the app to the terminal agent to scan and complete the check-in process.</p>
       </ul>
      </section>


      <section>
        <h2>DISCLAIMER</h2>
        <p>The above information is subject to terms and conditions governing foreign exchange in India as stipulated by the Reserve Bank of India. Any disputes arising under the terms of this document will be resolved through arbitration or due legal process in the city of New Delhi, India by a court of competent jurisdiction.</p>
        <p>Booking confirmations & sailings are governed by the cruise lines terms of carriage and guest conduct policy.</p>
        <p>Complete details are available in the cruise lines current year brochures or on their website <a href="https://www.royalcaribbean.com/">www.royalcaribbean.com</a> & <a href="https://www.celebritycruises.com/">www.celebritycruises.com</a> . The above are only some of the important points for your immediate reference and are subject to change without prior notice.</p>
      </section>
    </div>

    <ScrolltoTop/>

        <Footer/>
        
        </>
    );

}


export default TermsCondition ;